import { render, staticRenderFns } from "./OrderHistoryPart.vue?vue&type=template&id=1bfb2954&scoped=true&"
import script from "./OrderHistoryPart.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryPart.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryPart.vue?vue&type=style&index=0&id=1bfb2954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb2954",
  null
  
)

export default component.exports